import * as types from '../../mutation-types'
import RacesByTrainerService from '../../../services/racesByTrainer'

const actions = {
  get ({ commit, state }, id) {
    if (!id) {
      console.error('No trainer ID provided to getRacesByTrainer')
      return Promise.resolve()
    }
    
    return RacesByTrainerService.get(id)
      .then((response) => {
        if (response && response.data) {
          //pick 100 rows from the response
          //response.data = response.data.slice(0, 100);
          response.data.sort(function(a,b){
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(a.date) - new Date(b.date)
          })
          commit(types.GET_RACES_BY_TRAINER, {
            races: response.data
          })
        }
        return response
      })
      .catch(error => {
        console.error('Error getting races by trainer:', error)
        return Promise.reject(error)
      })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/racesByTrainer/actions.js